import type { ColorInstance } from "color";
import { createContext, type RefObject, useContext } from "react";

export interface ModalContextType {
  backgroundColor?: ColorInstance;
  modalRef?: RefObject<HTMLDivElement | null>;
}

export const ModalContext = createContext<ModalContextType | undefined>(
  undefined,
);

export const useModalContext = () => {
  const context = useContext(ModalContext);

  if (context === undefined) {
    throw new Error("useModalContext must be used within a Modal");
  }

  return context;
};
